import React, { Component } from 'react';
import Banner from '../../components/common/Banner';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer'
import Loading from '../../components/common/Loading';
import NoData from '../../components/common/NoData';
import { doc, getDoc } from 'firebase/firestore';
import { firestore } from '../../Config/FbConfig';
import { Styles } from "../styles/Faculties";

export default class Committee extends Component {

  state = { Datas: [] }

  //Load Data Here
  async componentDidMount() {
    const docRef = doc(firestore, "Library", "LibraryCommittee");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      var Data = []
      Object.entries(docSnap.data()).forEach(([key, value]) => {
        Data.push(Object.assign({ Id: key, Priority: value.Priority != undefined ?  value.Priority : "999"}, value))
      });
      Data.sort(function(a,b){ return a.Priority - b.Priority;});
      Data.length === 0 ? 
        this.setState({ Datas: "NO_999" }) : 
        this.setState({ Datas: Data})
    } else {
      this.setState({
        Datas: "NO_999"
      })
    }
  }

  render() {
    return (
      <div>
        {/* Header */}
        <Header />

        {/* Banner */}
        <Banner title="Library Committee" image="banner/Library-3.jpg" />

        <div className="container paddingtop-2">
          <div className="ttm-service-single-content-area">
            <div className="ttm-service-description">
              <div className="row">
                <div className="col-md-5">
                  <div className="ttm_single_image-wrapper">
                    <img className="img-fluid" src={process.env.PUBLIC_URL + "/assets/images/committee/committee.jpg"} alt="single-img-eighteen" />
                  </div>
                </div>
                <div className="col-md-7 justify" style={{ margin: "auto" }}><br/>
                  <p className="about-para">The Library Committee provides a forum for open discussion of matters relating to the Library and its services. BIT Central Library and Information Centre is governed by the Library Committee under the Chairperson Dr. Partha. AP. From Industrial Engineering and Management. The Committee was constituted to meet all the objectives, needs of the users, formation of policies, rules and regulations and implementation of policies in the Library effectively.</p><br/>
                  <div className="row paddingtop-2">
                    <div className="col-md-4">
                      <div className="ttm_single_image-wrapper">
                        <img className="img-fluid" src={process.env.PUBLIC_URL + "/assets/images/committee/committee-2.jpg"} alt="single-img-eighteen" />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="ttm_single_image-wrapper">
                        <img className="img-fluid" src={process.env.PUBLIC_URL + "/assets/images/committee/committee-3.jpg"} alt="single-img-eighteen" />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="ttm_single_image-wrapper">
                        <img className="img-fluid" src={process.env.PUBLIC_URL + "/assets/images/committee/committee-4.jpg"} alt="single-img-eighteen" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="section-title with-desc text-left clearfix paddingtop-2">
                    <div className="title-header" style={{ borderTopColor: "red" }}>
                      <h6 className="title">The Objectives of the Library Committee </h6>
                    </div>
                  </div>
                  <ul className="ttm-list ttm-list-style-icon paddingtop-2">
                    <li><i className="fa fa-check-circle ttm-textcolor-skincolor"></i>To outline the Library collection and development policy as and when required, in its implementation.</li>
                    <li><i className="fa fa-check-circle ttm-textcolor-skincolor"></i>To monitor and evaluate the trends and developments in information technologies, networking, Library automation, Library cooperation, Library timings etc., and to direct the Library in their day-to-day activities.</li>
                    <li><i className="fa fa-check-circle ttm-textcolor-skincolor"></i>Evaluate the suggestions offered by the Library users.</li>
                    <li><i className="fa fa-check-circle ttm-textcolor-skincolor"></i>Estimating the books, Journals procurement and allocation of budget accordingly recommendation of heads of the departments.</li>
                    <li><i className="fa fa-check-circle ttm-textcolor-skincolor"></i>To assist in stock verification, Weed out/Write off from the Library stock.</li>
                    <li><i className="fa fa-check-circle ttm-textcolor-skincolor"></i>Any other function as assigned by the chairperson of the Library Committee.</li>
                    <li><i className="fa fa-check-circle ttm-textcolor-skincolor"></i>To recommend the management to improve the Library resources and facilities need.</li>
                  </ul>
                </div>
                <div className="col-md-12">
                  <div className="section-title with-desc text-left clearfix paddingtop-2">
                    <div className="title-header" style={{ borderTopColor: "red" }}>
                      <h6 className="title">Roles & Responsibilities of the Library committee Members:</h6>
                    </div>
                  </div>
                  <ul className="ttm-list ttm-list-style-icon paddingtop-2">
                    <li><i className="fa fa-check-circle ttm-textcolor-skincolor"></i>The Library committee members will be their respective department LC coordinators.</li>
                    <li><i className="fa fa-check-circle ttm-textcolor-skincolor"></i>The Library committee monitors the procurement of books, Journals and the allocation of the budget according to the recommendation of the heads of the departments.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="section-title with-desc text-left clearfix paddingtop-2">
          <div className="title-header" style={{ borderTopColor: "red" }}>
            <h6 className="title">Committee Members</h6>
          </div>
        </div>
          <Styles>
            <div className="row">
              {
                this.state.Datas.length === 0 ? <Loading /> :
                  this.state.Datas === "NO_999" ? <NoData /> :
                    this.state.Datas.map((data, i) => (
                      <div className="col-md-3 ttm-box-col-wrapper d-flex align-items-stretch" key={i} style={{ marginBottom: "1rem" }}>
                        <div className="featured-imagebox featured-imagebox-blog">
                          <div className="featured-thumbnail" style={{ height: "20rem" }}>
                            <img className="img-fluid" alt="" src={data.Image} />
                          </div>
                          <div className="featured-content" style={{ marginTop: "-1.5rem" }}>
                            <div className="post-meta">
                              <h6 style={{ fontWeight: "bold", fontSize: "14px", color: "#98002e" }}>{data.Name}</h6><br />
                              <small dangerouslySetInnerHTML={{__html: data.Description.replaceAll("\\n","<br/>")}}/>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
              }
            </div>
          </Styles>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    )
  }
}
